import { CHAIN_ID, GOERLI_CHAIN_ID } from "./chainId";

export enum TerrainType {
  TallGrass = 1,
  Boulder,
  ChainBridgeStation,
}

type TerrainConfig = {
  emoji: string;
};

export const terrainTypes: Record<TerrainType, TerrainConfig> = {
  [TerrainType.TallGrass]: {
    emoji: CHAIN_ID ===  GOERLI_CHAIN_ID ? "🌳" : "🌴",
  },
  [TerrainType.Boulder]: {
    emoji: CHAIN_ID ===  GOERLI_CHAIN_ID ?  "🪨" : "🗿",
  },
  [TerrainType.ChainBridgeStation]: {
    emoji: "🪞",
  },
};
